import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Privacy Policy" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <p className="text-gray-700 mb-6 text-center">
            We are serious about our privacy. We lay emphasis on highest
            standards for safe and secure transactions and privacy of customer
            data. The document that follows highlights our policies & procedures
            and purposes for receiving your data.
          </p>

          <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-6 rounded-md">
            <p className="text-orange-700 font-semibold">Note :</p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>
                Our privacy policy can change at any given point of time without
                any prior notice. To ensure you stay aware of any amendments,
                kindly review this policy periodically.
              </li>
              <li>
                By browsing our Website you agree to be restricted by the terms
                and conditions of this Privacy Policy. In case you do not agree
                kindly do not use or visit our Website.
              </li>
              <li>
                Merely by using our Website, you explicitly provide consent to
                our usage and disclosure of your personal information in
                agreement with this Privacy Policy. This Privacy Policy is
                combined into and subject to the Terms of Use.
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Personal Information
            </h2>
            <p className="text-gray-700 mb-4">
              As per a part of our service, we gather and hoard your personal
              information which is timely provided by you. Our basic objective
              in doing so is to offer you a secure and safe, efficient,
              hassle-free customized experience. This permits us to offer
              services and features that most probable to meet your needs, and
              to customize our services to create a user experience that is
              better and easier. Most importantly, at the time of doing so we
              gather personal information from you that we regard as vital for
              meeting this purpose.
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                You can visit our Website without being a subscriber. Though
                once you become our subscriber, for us you are not anonymous.
                Where likely, we mark which fields are necessary and which are
                optional. At any time, you have the choice to not offer
                information by opting not to use a specific service or feature
                of that service. We may inevitably track your reading pattern
                based on the books you rent out.{" "}
              </li>
              <li>
                We make use of this information to do merchandise planning &
                recommendations to you and users like you. This information is
                compiled and analyzed on an aggregated basis. This information
                may contain the URL that you just came from, which URL you
                subsequently browse, tge information about your computer, and
                your IP address.
              </li>
              <li>
                We make use of data collection devices for instance "cookies" on
                specific pages of the Website to help analyze the flow of our
                web page, evaluate promotional effectiveness, We do not practice
                any control over the use of cookies by third parties.If you
                subscribe to our service, we gather information to aid us in
                delivering our service
              </li>
              <li>
                {" "}
                If you provide us your personal correspondence, for example
                emails or letters, or if other users or third parties provide us
                correspondence pertaining to your activities or postings on the
                Website, we may gather such type of information into a file
                specific to you.
              </li>
              <li>
                We gather personally identifiable information (email address,
                name, phone number, etc.) through you when you set up an account
                with us.
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Security Precautions
            </h2>
            <p className="text-gray-700">
              Our Website has strict security measures right in place to secure
              you from loss, misuse...
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Choice/Opt-Out
            </h2>
            <p className="text-gray-700">
              We offer all the users with this prospect to opt-out of receiving
              non-essential...
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Cancel / Refund
            </h2>
            <p className="text-gray-700">
              Kindly get in touch with us on our customer care in case of refund
              / cancellation...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
